import { render } from "./SendIcon.vue?vue&type=template&id=055ba1bd"
import script from "./SendIcon.vue?vue&type=script&lang=js"
export * from "./SendIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__